import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-remove-company',
  templateUrl: './remove-company.component.html',
  styleUrls: ['./remove-company.component.scss']
})
export class RemoveCompanyComponent implements OnInit {

  @Input() companyData: any
  @ViewChild('closeBtn') closeBtn: ElementRef;
  errorMsg: boolean;
  
  constructor(private authService: AuthenticationService, private router: Router, private appComp: AppComponent) { }

  ngOnInit(): void {
  }

  removeCompany(){
    this.appComp.loading = true;
    this.errorMsg = false;
    this.authService.removeCompany(this.companyData.id).then(res=>{
      console.log(res);
      this.closeBtn.nativeElement.click();
      this.router.navigateByUrl('/companies');
      this.appComp.loading = false;
    }, err=>{
      console.log(err);
      this.errorMsg = true;
      this.appComp.loading = false;
    })

    
  }

}
